function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M752.245 33.9658L705.495 0H666.537L713.995 33.9658H752.245Z",
  fill: "#15A0FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M752.245 33.9658L705.495 0H666.537L713.995 33.9658H752.245Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.65
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M818.118 33.9658L771.369 0H732.41L779.16 33.9658H818.118Z",
  fill: "#15A0FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M818.118 33.9658L771.369 0H732.41L779.16 33.9658H818.118Z",
  fill: "url(#paint1_linear)",
  fillOpacity: 0.65
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M883.287 33.9658L836.537 0H798.287L845.037 33.9658H883.287Z",
  fill: "#15A0FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M883.287 33.9658L836.537 0H798.287L845.037 33.9658H883.287Z",
  fill: "url(#paint2_linear)",
  fillOpacity: 0.65
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M949.165 33.9658L902.415 0H863.457L910.915 33.9658H949.165Z",
  fill: "#15A0FF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M949.165 33.9658L902.415 0H863.457L910.915 33.9658H949.165Z",
  fill: "url(#paint3_linear)",
  fillOpacity: 0.65
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1015.04 33.9658L967.582 0H929.332L976.082 33.9658H1015.04Z",
  fill: "#15A0FF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1015.04 33.9658L967.582 0H929.332L976.082 33.9658H1015.04Z",
  fill: "url(#paint4_linear)",
  fillOpacity: 0.65
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1080.21 33.9658L1033.46 0H995.209L1041.96 33.9658H1080.21Z",
  fill: "#15A0FF"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1080.21 33.9658L1033.46 0H995.209L1041.96 33.9658H1080.21Z",
  fill: "url(#paint5_linear)",
  fillOpacity: 0.65
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M579 754.681L649.125 705H687.375L616.542 755.188L579 754.681Z",
  fill: "#15A0FF"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M579 754.681L649.125 705H687.375L616.542 755.188L579 754.681Z",
  fill: "url(#paint6_linear)",
  fillOpacity: 0.65
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M121.833 12.6719H92.7916L0 79.0826V100.375L121.833 12.6719Z",
  fill: "#15A0FF"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M121.833 12.6719H92.7916L0 79.0826V100.375L121.833 12.6719Z",
  fill: "url(#paint7_linear)",
  fillOpacity: 0.65
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 745.012,
  y1: 0.0000161522,
  x2: 680.262,
  y2: -12.4461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 810.885,
  y1: 0.0000161522,
  x2: 746.135,
  y2: -12.4461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 876.114,
  y1: 0.0000161522,
  x2: 811.861,
  y2: -12.2484,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 941.932,
  y1: 0.0000161522,
  x2: 877.182,
  y2: -12.4461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 1007.81,
  y1: 0.0000161522,
  x2: 943.057,
  y2: -12.4461,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 1073.04,
  y1: 0.0000161522,
  x2: 1008.78,
  y2: -12.2485,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 678.229,
  y1: 705,
  x2: 595.566,
  y2: 691.403,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 111.552,
  y1: 12.6719,
  x2: 17.1661,
  y2: 2.6841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2958FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.467083,
  stopColor: "#E248FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#12FED9"
})));

function SvgFeaturedContentBgBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1081 756",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedContentBgBorder);
export default __webpack_public_path__ + "static/media/featured-content-bg-border.bc672cb9.svg";
export { ForwardRef as ReactComponent };